// extracted by mini-css-extract-plugin
export default {"page":"style_page__NRA5I","content":"style_content__gKgB0","wrapper":"style_wrapper__+QBFj"};